import { IListItem } from "@nkr/models/list-item";
import { AuthActionCreators, IGet } from "@nkr/store/authorization";
import { ICenterAddressLookupDataResponse } from "@nkr/store/center";
import { useAppHookContext } from "@nkr/utils/rest-api";
import { useEffect, useState } from "react";

interface IRetVal {
    loading: boolean,
    error: string,
    addressTypes: IListItem[],
    states: IListItem[],
}

function useCenterAddressLookupData(): IRetVal {
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string>('');
    const [addressTypes, setAddressTypes] = useState<IListItem[]>([]);
    const [states, setStates] = useState<IListItem[]>([]);

    const { dispatch } = useAppHookContext();

    const reset = () => {
        setStates([]);
        setAddressTypes([]);
    }

    useEffect(() => {

        setLoading(true);
        setError('');

        const fetchData = async () => {

            var config: IGet = {
                url: `${__API__}/center/address/lookup-data`
            };

            try {

                const response: ICenterAddressLookupDataResponse = await dispatch(AuthActionCreators.apiGet(config));

                if (response && response.data.results && response.data.success) {
                    setStates(response.data.results.stateList)
                    setAddressTypes(response.data.results.addressTypeList);
                } else {
                    setError('Unable to load center address lookup data');
                    reset();
                }

            } catch (err) {
                reset()
                setError(err)
            } finally {
                setLoading(false);
            }
        }

        fetchData();

    }, []);

    return { loading, error, addressTypes, states }
}


export default useCenterAddressLookupData